import CommonHeader from '../pages/Head'
import React from 'react'
import {Link} from "react-router-dom";
import axios from 'axios';
import ApplyImg from '../images/Apply Now_1.jpg'
import ExistCustomer from '../images/Existing_Customers.jpg'
import CanMoney from '../images/payday-payday-loans-ca-4.jpg'
import apiaddressredirect from "../apiaddressredirect.json";


class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:''};				
	}

	componentDidMount() {				
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	render() {		
		return(
			<div>
				<CommonHeader titles="Home"/>				
				<h1 className="headings" style={{textAlign:"center",color:"green"}}><small>{this.state.CompName}--Payday Loan Provider for Canadians</small></h1>				
				<div id="contentwrapper" >
					<div id="contentcolumn">
						<Link to = {{pathname: apiaddressredirect.IPAddress+"Apply"}} target="_blank"><img border="0" src={ApplyImg} alt="Payday loans application"/></Link>						
						<Link to = {{pathname: apiaddressredirect.IPAddress+"Member"}} target="_blank"><img border="0" src={ExistCustomer} alt="Payday loans Returning Customers"/></Link>						
					</div>
				</div>
				<div id="rightcolumn">
					<div className="innertext">
						<b style={{color:"green"}}>No Fax</b><br/>
						<b style={{color:"green"}}>Fast and Easy</b><br/>
						<b style={{color:"green"}}>No hidden cost</b><br/>
						<b style={{color:"green"}}>No Credit Check</b><br/>
						<b style={{color:"green"}}>Up to $600 until next pay day</b><br/>
						<b style={{color:"green"}}>Cash advance deposited directly to your account</b><br/>
					</div>
				</div>
				<div id="leftcolumn" title="Your payday loans"><img src={CanMoney} alt="Your Payday loans and cash advance"/></div>
					<div id="bottom">				
				<h1 style={{color:"blue"}}>{this.state.CompName} makes difference</h1>
				<h4 style={{color:"grey"}}><Link style={{color:"#0040ff"}} to = "/" title="Your payday loans">{this.state.CompName}</Link> is dedicated to putting Canadians financial needs first. 
					Whenever you need fast cash, then you have come to the right place. It is very easy to apply for a payday loan online at any time 
					at <Link style={{color:"#0040ff"}} to = "/" title="Your payday loans"> {this.state.CompName}</Link>. At <Link style={{color:"#0040ff"}} to = "/" title="Your payday loans">{this.state.CompName}</Link>, 
					we don't perform credit checks, which helps us to provide fast loan approvals and better access to short term personal loans in Canada. That is why we have 
					made the process of applying for a payday loan simple. Payday loans are a short-term source of credit that should be used for unexpected emergencies and other urgent needs.</h4>					
				<h4 style={{color:"grey"}}>If you are 18 years of age (minimum applicant age for our payday loans) or above and locating in Canada, you are welcome to use our 
					friendly services. No hassle, no credit check required, no misleading, no hidden cost. We are always willing to be a support. If you are ready to 
					experience the simplest payday loan online then all you need to do is <Link to = {{pathname: apiaddressredirect.IPAddress+"Apply"}} target="_blank"><span className="words">
					click here</span></Link> to start your application.</h4>
				<h1 style={{color:"#0040ff"}}><Link style={{color:"#0040ff"}} to = {{pathname: apiaddressredirect.IPAddress+"Apply"}} target="_blank">Apply Now!</Link> Get approved today!</h1>
				</div>
				<br/>					
			</div>
		)
	}
}

export default HomtContents